import { render, staticRenderFns } from "./SystemNotesV2026.vue?vue&type=template&id=a95af7a8&scoped=true"
import script from "./SystemNotesV2026.vue?vue&type=script&lang=js"
export * from "./SystemNotesV2026.vue?vue&type=script&lang=js"
import style0 from "./SystemNotesV2026.vue?vue&type=style&index=0&id=a95af7a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95af7a8",
  null
  
)

export default component.exports